<template>
<div class="bu">
  <div>
    <span class="bu__title">Bulk Update</span>
    <button class="selected-chip">
        {{ selectedIdsText }}
    </button>
  </div>
  <div>
    <div class="bu__row">
      <BulkUpdateFields
        ref="bulkUpdateFields"
        @fieldData="updateFields($event)"
        :urlOpts="urlOpts"
        :msvLabels="msvLabels"
        :showDifficultyScore="showDifficultyScore"
      />
    </div>

    <div class="bu__controls">
      <button class="bu__button bu__button_cancel"
              @click="close()">
        Cancel
      </button>
      <button class="bu__button bu__button_submit"
              @click.prevent="apply()">
        Bulk Update
      </button>
    </div>
  </div>
</div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'
import BulkUpdateFields from './BulkUpdateFields'

export default {
  name: 'BulkUpdate',
  components: { BulkUpdateFields },
  mixins: [BaseModalMixins],
  props: {
    urlOpts: Array,
    selectedIds: Array,
    filteredKeywords: Number,
    msvLabels: Array,
    showDifficultyScore: Boolean
  },
  data () {
    return {
      form: {
        score: null,
        url: null,
        difficultyScore: null,
        msv1: null,
        msv2: null,
        msv3: null,
        msv4: null,
        selectedIds: this.selectedIds
      }
    }
  },
  computed: {
    selectedIdsText () {
      let count = this.selectedIds.length
      let noneOrMultiple = count !== 1
      return `Selected ${count} Item${noneOrMultiple ? 's' : ''}`
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    apply () {
      this.$refs.bulkUpdateFields.updateFields()
      this.$emit('apply', this.form)
    },
    updateFields (fields) {
      fields.forEach(obj => {
        switch (obj.field) {
          case 'mappedUrl':
            this.form.url = obj.value
            break
          case 'relScore':
            this.form.score = obj.value
            break
          case 'metric_msv_broad_adjusted_1':
            this.form.msv1 = obj.value
            break
          case 'metric_msv_broad_adjusted_2':
            this.form.msv2 = obj.value
            break
          case 'metric_msv_broad_adjusted_3':
            this.form.msv3 = obj.value
            break
          case 'metric_msv_broad_adjusted_4':
            this.form.msv4 = obj.value
            break
          case 'difficultyScore':
            this.form.difficultyScore = obj.value
            break
        }
      })
    }
  }
}

</script>

<style scoped lang="scss">
  .selected-chip {
    border-radius: 15px;
    height: 30px;
    display: block;
    margin: 0 auto;
    background-color: $rfx-medium-march;
    color: #fff;
    outline: none;
    border: none;
    font-size: 13px;
    min-width: 120px;
    padding: 0 15px;
    margin-top: 15px;
    cursor: default;
  }
  .bu {
    &__title {
      display: block;
      text-align: center;
      font-size: 32px;
      font-weight: 500;
    }

    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    &__msv {
      border: none;
      outline: none;
      width: 91%;
      height: 98%;
    }

    &__table {
      border: 1px solid $rfx-light-steel;
      border-radius: 4px;
      border-collapse: collapse;
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 30px;
    }

    &__tr {
      display: flex;
      align-content: space-between;
      &:last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    &__td {
      height: 40px;
      border-bottom: 1px solid $rfx-light-steel;

      &__input {
        padding-left: 30px;
        &:hover {
          background-color: $rfx-light-steel;
          cursor: pointer;
        }
        &:focus {
          background-color: $rfx-light-steel;
        }

      }

      &__title {
        padding-left: 30px;
        padding-top: 12px;
      }

      &__left {
        width: 40%;
        display: inline-flex;
      }

      &__right {
        width: 60%;
        border-left: 1px solid $rfx-light-steel;
        &:hover {
          background-color: $rfx-light-steel;
          cursor: pointer;
        }
        &:focus-within {
          background-color: $rfx-light-steel;
        }
      }
    }

    &__row {
      margin-top: 30px;
    }

    &__input {
        &__col-left {
          width: 30%;
        }

        &__col-right {
          width: 60%;
        }

        &_invalid[type='text'] {
            border: 1px solid $rfx-red;
            border-radius: 4px;
        }
    }

    &__label {
        display: block;
        font-weight: 600;
        margin-bottom: 5px;
        color: $rfx-dark-march;
    }

    &__radio_label {
        cursor: pointer;
    }

    &__controls {
        display: flex;
        justify-content: flex-end;
        margin-top: 30px;
    }

    &__button {
        width: 100px;
        height: 40px;
        border-radius: 4px;
        font-size: 10px;
        font-weight: 900;
        text-transform: uppercase;
        margin-left: 30px;
        border: none;
        outline: none;
        cursor: pointer;

        &_submit {
            background-color: $rfx-medium-march;
            color: #fff;
        }

        &_cancel {
            color: $rfx-dark-march;
            background-color: #fff;
        }
    }

}

</style>
